import { AppBar, Box, Toolbar, Typography } from "@mui/material";
import React from "react";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import moment from "moment";

export default function PortalHeader({ logo, title, date }) {
  return (
    <AppBar
      position="static"
      color="default"
      elevation={1}
      sx={{ bgcolor: "#fff", mb: 2, borderRadius: 2 }}
    >
      <Toolbar>
        {/* Left Side: Logo & Title */}
        <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
          <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
              width: 180,
              mr: 2,
              borderRight: "1px solid black",
            }}
          />
          <Typography
            variant="h6"
            component="h1"
            sx={{ fontWeight: 700, color: "#333" }}
          >
            {title}
          </Typography>
        </Box>

        {/* Right Side: Date */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            color: "text.secondary",
          }}
        >
          <CalendarTodayIcon sx={{ fontSize: 18, mr: 1 }} />
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            {moment(date).format("YYYY-MM-DD")}
          </Typography>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
